<template>
<vs-card class="cardx">
  <div class="vehicle_div1">
    <div class="ps_vehicle_btnAdd">
      <vs-button @click="create_action(4)" color="darkgreen" type="border" icon="add"> Agregar nuevo Vehículo </vs-button>
    </div>
    <div class="ps_vehicle_btnAdd">
      <vs-button @click="create_action(3)" color="darkgreen" type="border" icon="add"> Agregar nuevo Modelo </vs-button>
    </div>
    <div class="ps_vehicle_btnAdd">
      <vs-button @click="create_action(2)" color="darkgreen" type="border" icon="add"> Agregar nueva Marca </vs-button>
    </div>
    <div class="ps_vehicle_btnAdd">
      <vs-button @click="create_action(1)" color="darkgreen" type="border" icon="add"> Agregar nuevo Tipo </vs-button>
    </div>
  </div>
  <div v-if="showA" class="vehicle_div2">
    <vs-table :max-items="$store.state.pagination" pagination search :data="vehicle">
      <template slot="thead">
      <vs-th sort-key="plate">
          Plate
      </vs-th>
      <vs-th sort-key="model">
          Modelo
      </vs-th>
      <vs-th sort-key="brand">
          Marca
      </vs-th>
      <vs-th sort-key="type">
          Type
      </vs-th>
      <vs-th sort-key="autonomous">
          Autónomo
      </vs-th>
      </template>

      <template slot-scope="{data}">
      <vs-tr :style="data[indextr].active == true? 'background-color: rgb(0 255 37 / 10%);':data[indextr].active == false?'background-color: rgb(255 0 0 / 10%)':'background-color: none'" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].plate">
          {{data[indextr].plate}}
          </vs-td>
          <vs-td :data="data[indextr].model">
          {{data[indextr].model}}
          </vs-td>
          <vs-td :data="data[indextr].brand">
          {{data[indextr].brand}}
          </vs-td>
          <vs-td :data="data[indextr].type">
          {{data[indextr].type}}
          </vs-td>
          <vs-td :data="data[indextr].autonomous">
          {{data[indextr].autonomous}}
          </vs-td>
      </vs-tr>
      </template>
    </vs-table>
  </div>
  <div v-if="!showA" class="vehicle_div3">
    <vs-alert class="ps_alert_vevhicle" title="Information" color="rgb(231, 154, 23)">
            No Hay Datos Para Mostrar.
    </vs-alert>
  </div>
  <div>
    <Modal :show="showModal" @close="showModal = false">
      <template #body>
        <VehicleTypeAdd v-if="$data.action === 1"></VehicleTypeAdd>
        <VehicleBrandAdd v-if="$data.action === 2"></VehicleBrandAdd>
        <VehicleModelAdd v-if="$data.action === 3"></VehicleModelAdd>
        <VehicleAdd v-if="$data.action === 4"></VehicleAdd>
      </template>
    </Modal>
  </div>
</vs-card>
</template>
<script>
import axios from 'axios'
import Modal from './components/utils/Modal.vue';
import VehicleTypeAdd from './components/vehicle/VehicleTypeAdd.vue';
import VehicleBrandAdd from './components/vehicle/VehicleBrandAdd.vue';
import VehicleModelAdd from './components/vehicle/VehicleModelAdd.vue';
import VehicleAdd from './components/vehicle/VehicleAdd.vue';

export default {
    name: "vehicleList",
    props:{
    },
    components: {
    Modal,
    VehicleTypeAdd,
    VehicleBrandAdd,
    VehicleModelAdd,
    VehicleAdd
},
    data:()=>({
    action: Number,
    showA: false,
    vehicle: [],
    showModal: false,
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    vehicleList(){
      const url_api =  this.$store.state.url_api
      axios.get(url_api + 'api/vehicle').then(response => {
        this.vehicle = response.data
        if(response.data.isok === false){
          this.showA = false
        }
        else{
          this.showA = true
        }
      })
      .catch((error) => {
        console.error(error)
      })
    },
    create_action(action){
      this.action = action
      this.showModal = true
    }
  },
  mounted(){
  this.vehicleList()
  },
  watch: {
    showModal: function(val){
      this.vehicleList()
    }
  }
}
</script>
<style>
  .vehicle_div1{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    width: auto;
    height: 50px;
  }

  .ps_vehicle_btnAdd{
    float: right;
    width: auto;
    margin-right: 3px;
  }

  .vehicle_div2{
    margin-top: 20px;
    width: auto;
    height: 200px;
  }
  .vehicle_div3{
    text-align:center;
  }
  .ps_alert_vevhicle{
    margin:0px auto;
    margin-top: 10px;
    width: max-content;
    min-width: 300px;
  }
  .vs-table--search-input{
    border: 0.5px solid rgb(43 43 43 / 49%);
    border-radius: 8px;
  }
</style>